import styled from 'styled-components'
import { Button, ButtonProps } from '@pancakeswap/uikit'
import { useSwitchNetworkLoading } from 'hooks/useSwitchNetworkLoading'
import { useSetAtom } from 'jotai'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { hideWrongNetworkModalAtom } from './NetworkModal'
import Trans from './Trans'

const StyledButton = styled(Button)`
  height: 40px;
  border-radius: 12px;
  box-shadow: none;
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  background-color: #2e81ff;
  color: #fff !important;

  &:disabled {
    background: #6a768c !important;
    color: #49505e !important;
    fill: #2e5198;
    > * {
      color: #49505e !important;
      fill: #2e5198;
    }
  }
`

const wrongNetworkProps: ButtonProps = {
  variant: 'danger',
  disabled: false,
  children: <Trans>Wrong Network</Trans>,
}

export const CommitButton = (props: ButtonProps) => {
  const { isWrongNetwork } = useActiveChainId()
  const [switchNetworkLoading] = useSwitchNetworkLoading()
  const setHideWrongNetwork = useSetAtom(hideWrongNetworkModalAtom)

  return (
    <StyledButton
      {...props}
      onClick={(e) => {
        if (isWrongNetwork) {
          setHideWrongNetwork(false)
        } else {
          props.onClick?.(e)
        }
      }}
      {...(switchNetworkLoading && { disabled: true })}
      {...(isWrongNetwork && wrongNetworkProps)}
    />
  )
}
